/**
 * useHorseListSort — mode de tri de « Mes Chevaux », mémorisé dans le compte (G7)
 *
 * Monté dans useAppState (et non dans HorseList) : le choix doit survivre à la
 * navigation, alors que HorseList est démonté à chaque changement de page.
 * currentUser n'est volontairement PAS mis à jour après l'enregistrement :
 * useAppState recharge chevaux et sessions à chaque changement de currentUser.
 * L'état local fait foi pendant la session ; la préférence serveur est relue
 * au prochain chargement.
 */
import { useState, useEffect, useCallback } from 'react';
import { normalizeSortMode } from './horseListSort';
import { updatePreferences } from '../settings/profileService';

export default function useHorseListSort(currentUser) {
  const userId = currentUser?.id || currentUser?._id || null;
  const saved = currentUser?.preferences?.horseListSort;
  const [mode, setMode] = useState(() => normalizeSortMode(saved));
  const [saveError, setSaveError] = useState(false);

  // Relecture à la connexion (ou au changement de compte)
  useEffect(() => {
    setMode(normalizeSortMode(saved));
    setSaveError(false);
  }, [userId, saved]);

  const changeMode = useCallback(async (next) => {
    const value = normalizeSortMode(next);
    setMode(value); // optimiste : l'ordre change tout de suite
    setSaveError(false);
    try {
      await updatePreferences({ horseListSort: value });
    } catch (err) {
      // Non bloquant : l'ordre choisi reste appliqué pour cette session
      console.error('saveHorseListSort:', err);
      setSaveError(true);
    }
  }, []);

  return { mode, changeMode, saveError };
}
